<template>
    <div>
        <form novalidate @submit.prevent="validateForm">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-50 md-small-size-100">
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('first_name')">
                            <label for="first_name">Voornaam</label>
                            <md-input
                                required
                                name="first_name"
                                id="first_name"
                                v-model="form.first_name"
                                :disabled="sending"
                            />
                            <span class="md-error" v-if="!$v.form.first_name.required">Verplicht in te vullen!</span>
                            <span class="md-error" v-else-if="!$v.form.first_name.minLength">Naam is te kort</span>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('last_name')">
                            <label for="last_name">Achternaam</label>
                            <md-input
                                required
                                name="last_name"
                                id="last_name"
                                v-model="form.last_name"
                                :disabled="sending"
                            />
                            <span class="md-error" v-if="!$v.form.last_name.required">Verplicht in te vullen!</span>
                            <span class="md-error" v-else-if="!$v.form.last_name.minLength">Naam is te kort</span>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('main_address.address')">
                            <label for="address">Straat</label>
                            <md-input
                                required
                                name="address"
                                id="address"
                                v-model="form.main_address.address"
                                :disabled="sending"
                            />
                            <span class="md-error" v-if="!$v.form.main_address.address.required"
                                >Verplicht in te vullen!</span
                            >
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('main_address.city')">
                            <label for="city">Stad</label>
                            <md-input
                                required
                                name="city"
                                id="city"
                                v-model="form.main_address.city"
                                :disabled="sending"
                            />
                            <span class="md-error" v-if="!$v.form.main_address.city.required"
                                >Verplicht in te vullen!</span
                            >
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('main_address.zip_code')">
                            <label for="city">Postcode</label>
                            <md-input
                                required
                                name="zip_code"
                                id="zip_code"
                                v-model="form.main_address.zip_code"
                                :disabled="sending"
                            />
                            <span class="md-error" v-if="!$v.form.main_address.zip_code.required"
                                >Verplicht in te vullen!</span
                            >
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('phone')">
                            <label for="phone">Tel.nr</label>
                            <md-input
                                name="phone"
                                id="phone"
                                v-model="form.main_address.telephone_phone"
                                :disabled="sending"
                            />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('phone')">
                            <label for="mobile_phone">GSM.nr</label>
                            <md-input
                                name="mobile_phone"
                                id="mobile_phone"
                                v-model="form.main_address.mobile_phone"
                                :disabled="sending"
                            />
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('email')">
                            <label for="email">Email</label>
                            <md-input required name="email" id="email" v-model="form.email" :disabled="sending" />
                            <span class="md-error" v-if="!$v.form.email.required">Verplicht in te vullen!</span>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-90 md-small-size-100">
                        <md-field :class="getValidationClass('remarks')">
                            <label for="remarks">Opmerkingen</label>
                            <md-textarea
                                name="remarks"
                                id="remarks"
                                v-model="form.remarks"
                                :disabled="sending"
                            ></md-textarea>
                        </md-field>
                    </div>
                </div>
                <div class="md-layout-item md-size-100">
                    <md-button type="submit" class="md-primary md-raised" :disabled="sending">Volgende</md-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { quoteStore } from '@/store/quote/quote.store';
import { validationMixin } from 'vuelidate';
import { IVuelidateComponentOptions } from '@/services/entities/vuelidate.entity';
import { email, minLength, required } from 'vuelidate/lib/validators';
import { IClientDataEntity } from '@phrospr/lib-models';

@Component({
    mixins: [validationMixin],
    validations: {
        form: {
            language: { required },
            first_name: { required, minLength: minLength(2) },
            last_name: { required, minLength: minLength(2) },
            email: { required, email },
            mobile_phone: {},
            telephone_phone: {},
            gender: {},
            main_address: {
                address: { required },
                city: { required },
                zip_code: { required },
                country: {},
            },
            address: { required },
            city: { required },
            phone: {},
            remarks: {},
            company_data: {
                company_name: {},
            },
        },
    },
} as IVuelidateComponentOptions)
export default class QuoteClientCreate extends Vue {
    @Prop() form: IClientDataEntity;

    invalidForm = false;
    $v: any;
    sending = false;

    constructor() {
        super();
    }

    validateForm() {
        this.invalidForm = false;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            quoteStore.commit('quoteV2AddClient', this.form);
        } else this.invalidForm = true;
    }

    getValidationClass(fieldName) {
        const keys = fieldName.split('.');
        let field = this.$v.form[keys[0]];
        for (let i = 1; i < keys.length; i++) field = field[keys[i]];
        if (field) {
            return {
                'md-invalid': field.$invalid && field.$dirty,
            };
        }
    }
}
</script>

<style lang="scss" scoped></style>
